import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";


export const getTerritoryByOrgUnit = async (OrgUnitId?: number | any) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.Beat.GET_TERRITORY_BY_ORGUNIT}/${OrgUnitId}`);
    console.log("🚀 ~ file: BeatRepository.ts ~ line 9 ~ getTerritoryByOrgUnit ~ response", response);
    // return response?.data;
    let dt = response?.data?.data;
    if (dt && Object.keys(dt)?.length > 0) {
        let data = Object.keys(dt).reduce((arr: any, id: any) => {
            arr.push({ id: id, label: dt[id] });
            return arr;
        }, []);
        return { data, response: dt };
    }
    return { data: [], response: {} };

};
export const getTownByOrgUnitIDTerritoryId = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Beat.GET_TOWN_BY_TERRITORYID_ORGUNITID, { params: params });
    console.log("🚀 ~ file: BeatRepository.ts ~ line 9 ~ getTownByOrgUnitIDTerritoryId ~ response", response);
    let dt = response?.data?.data;
    if (dt && Object.keys(dt)?.length > 0) {
        let data = Object.keys(dt).reduce((arr: any, id: any) => {
            arr.push({ id: id, label: dt[id] });
            return arr;
        }, []);
        return { data, response: dt };
    }
    return { data: [], response: {} };

};
// getBeats
export const getBeats = async (params?: Record<string, any>) => {
    const consfig = params ?{params}:{};

    const response = await axiosInstance.get(
        API_ENDPOINTS.Beat.GET_BEATS,consfig);
    return response?.data;
};
export const getOrgUnits = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.EMPLOYEE.GET_ORG_UNITS
    );
    let dt = response?.data?.data;
    if (dt && Object.keys(dt)?.length > 0) {
        let data = Object.keys(dt).reduce((arr: any, id: any) => {
            arr.push({ id: id, label: dt[id] });
            return arr;
        }, []);
        console.log(
            "🚀 ~ file: BeatRepository.ts ~ line 21 ~ getOrgUnits ~ response",
            data
        );
        return { data, response: dt };
    }
    return { data: [], response: {} };
};

export const addBeat = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Beat.ADD_BEAT, body);
};
export const updateBeat = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Beat.UPDATE_BEAT}/${id}`, body);
};

export const getBeatOutlets = async (beatId?: any, params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.Beat.GET_BEAT_OUTLETS}/${beatId}`, { params: params });
    console.log(
        "🚀 ~ file: BeatRepository.ts ~ line 20 ~ getBeats ~ response",
        response
    );
    return response?.data;
};

export const getBeatById = async (params?: Record<string, any>,id?:number) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.Beat.GET_BEAT_BY_ID}/${id}`, { params });
    return response?.data;
};

// Territory and Town Fiter

export const getTownFilter = async (params?: Record<string, any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Beat.GET_TERRITORY_TOWN_FILTER}`, { params: params })
    const rowData = await response?.data;
    // console.log('logggggggggg', rowData)

    const formatedData = [...Object.entries(rowData?.data?.TownsData || {}).map(([key, value]) => ({
        id: key,
        label: value
    }))]
    return { rowData, formatedData };
}



export const getAllTerritory = async (params?: Record<string, any>) => {
    let response = await axiosInstance.get(`${API_ENDPOINTS.Terrritoris.GET_TERRITORIS_LIST}`, { params: params })
    const data = await response?.data;
    // console.log('rowData----getAllTerr', data?.data?.data);
    let formatedData = data?.data?.data?.reduce((arr:any,item:any)=>{
          arr.push({id:Number(item?.TerritoryId),label:item?.TerritoryName})
          return arr;
    },[])
    return { data,formatedData };
}